import { NavLink } from '@hulu/react-router-dom';
import React, { PropsWithChildren } from 'react';

import { Wrapper } from './styled';

type Props = PropsWithChildren<{
  to: string;
  className?: string;
  dataTestId?: string;
}>;

const Link = ({ to, className, children, dataTestId = 'navLink' }: Props): JSX.Element => {
  return (
    <Wrapper className={className} data-testid={dataTestId}>
      <NavLink to={to}>{children}</NavLink>
    </Wrapper>
  );
};

export default Link;
